/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Practice_StarsInputs */



/**
* | output |
* | --- |
* | "{score} out of 5" |
*
* @param {Practice_StarsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_stars = /** @type {((inputs: Practice_StarsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_StarsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.score} van 5`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.score} sur 5`)
	return /** @type {LocalizedString} */ (`${i?.score} out of 5`)
});